const option = [
    { id: '1', name: 'มกราคม' },
    { id: '2', name: 'กุมภาพันธ์' },
    { id: '3', name: 'มีนาคม' },
    { id: '4', name: 'เมษายน' },
    { id: '5', name: 'พฤษภาคม' },
    { id: '6', name: 'มิถุนายน' },
    { id: '7', name: 'กรกฎาคม' },
    { id: '8', name: 'สิงหาคม' },
    { id: '9', name: 'กันยายน' },
    { id: '10', name: 'ตุลาคม' },
    { id: '11', name: 'พฤศจิกายน' },
    { id: '12', name: 'ธันวาคม' }
]

export default {
    option: option
};